<script setup>
import { computed } from "vue";
import STATUS_TONE_MAP from "@/Constans/StatusToneMap";

const props = defineProps({
  value: {
    type: [String, Number],
    default: 0,
  },
  type: {
    type: String,
    default: "cancelado",
  },
  size: {
    type: String,
    default: "sm",
    validator(value) {
      return ["sm", "xs"].includes(value);
    },
  },
});

const SIZE_MAP = Object.freeze({
  sm: { size: "1.4rem", fontSize: "0.68rem" },
  xs: { size: "1.0rem", fontSize: "0.55rem" },
});

const resolvedPalette = computed(() => STATUS_TONE_MAP[props.type] || STATUS_TONE_MAP.cancelado);
const resolvedSize = computed(() => SIZE_MAP[props.size] || SIZE_MAP.sm);
const displayValue = computed(() => {
  if (props.value === null || props.value === undefined || props.value === "") return "0";
  return String(props.value);
});

const badgeStyle = computed(() => ({
  "--argon-counter-color": resolvedPalette.value.color,
  "--argon-counter-bg": resolvedPalette.value.background,
  "--argon-counter-border": resolvedPalette.value.border,
  "--argon-counter-shadow": `${resolvedPalette.value.border}40`,
  "--argon-counter-size": resolvedSize.value.size,
  "--argon-counter-font-size": resolvedSize.value.fontSize,
}));
</script>

<template>
  <span class="argon-counter-badge" :style="badgeStyle">
    {{ displayValue }}
  </span>
</template>

<style scoped>
.argon-counter-badge {
  align-items: center;
  background: var(--argon-counter-bg);
  border: 1px solid var(--argon-counter-border);
  border-radius: 999px;
  color: var(--argon-counter-color);
  display: inline-flex;
  font-size: var(--argon-counter-font-size);
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  justify-content: center;
  line-height: 1;
  height: var(--argon-counter-size);
  min-width: var(--argon-counter-size);
  padding: 0 0.28rem;
  flex-shrink: 0;
}
</style>
